var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___cV9PRX",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___cV9PRX",
  "Se": "ChannelAttachmentArea.module__upload___cV9PRX",
  "PO": "ChannelAttachmentArea.module__uploadContainer___cV9PRX",
  "il": "ChannelAttachmentArea.module__mediaContainer___cV9PRX",
  "BA": "ChannelAttachmentArea.module__clickableMedia___cV9PRX",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___cV9PRX",
  "R": "ChannelAttachmentArea.module__hidden___cV9PRX",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___cV9PRX",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___cV9PRX",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___cV9PRX",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___cV9PRX",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___cV9PRX",
  "p6": "ChannelAttachmentArea.module__spoiler___cV9PRX",
  "$_": "ChannelAttachmentArea.module__media___cV9PRX",
  "_A": "ChannelAttachmentArea.module__tags___cV9PRX",
  "H6": "ChannelAttachmentArea.module__filenameContainer___cV9PRX",
  "iW": "ChannelAttachmentArea.module__filename___cV9PRX",
  "VF": "ChannelAttachmentArea.module__fileDetails___cV9PRX",
  "Ov": "ChannelAttachmentArea.module__fileSize___cV9PRX",
  "i_": "ChannelAttachmentArea.module__fileExtension___cV9PRX",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___cV9PRX",
  "KY": "ChannelAttachmentArea.module__actionBar___cV9PRX" + " " + __webpack_require__(180357)["KE"],
  "x6": "ChannelAttachmentArea.module__button___cV9PRX" + " " + __webpack_require__(180357)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___cV9PRX",
  "le": "ChannelAttachmentArea.module__actionBarIcon___cV9PRX",
  "s3": "ChannelAttachmentArea.module__altTag___cV9PRX",
  "Kk": "ChannelAttachmentArea.module__icon___cV9PRX",
  "Dp": "ChannelAttachmentArea.module__iconImage___cV9PRX",
  "vt": "ChannelAttachmentArea.module__videoModal___cV9PRX",
  "j": "ChannelAttachmentArea.module__videoContainer___cV9PRX",
  "yF": "ChannelAttachmentArea.module__divider___cV9PRX",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___cV9PRX",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___cV9PRX",
};

module.exports = exports;
